import AjaxService from './AjaxService';
import auth from './auth';
import camelize from './camelize';

import documents from './documents';
import enums from './enums';
import errorHttpIntercept from './errorHttpIntercept';
import eventsMgr from './eventsMgr';
import findingsBg from './findingsBg';

import ping from './ping';
import safeApply from './safeApply';
import serverTime from './serverTime';
import signalr from './signalr';
import statusHelpers from './statusHelpers';
import environmentHelper from './environmentHelper';
import dateFormattingHelper from './formatting/dateFormattingHelper';
import ageHelper from './helpers/ageHelper';
import dateHelper from './helpers/dateHelper';


import techpadVersioningIntercept from './techpadVersioningIntercept';
import throttle from './throttle';
import timedMessage from './timedMessage';
import timeoutHttpIntercept from './timeoutHttpIntercept';
import uuid from './uuid';

import mathHelper from './svg/mathHelper';
import scarDrawer from './svg/scarDrawer';

import {module} from '../app';
import {TechpadOptions} from "./techpadOptions";
import {ModalService} from './modal';
import {TechpadConfig} from './techpadConfig';
import {CachedStorageService} from './cacheStorage';
import {DataRetrieverService} from "./dataRetriever";
import {LocalStorage} from './localStorage';
import {pubsubService} from './pubsub.service';
import {DatePickerService} from './date-picker';

module.service('cacheStorageService', CachedStorageService);
module.service('modalService', ModalService);
module.service('techpadConfig', TechpadConfig);
module.service('techpadOptions', TechpadOptions);
module.service('dataRetrieverService', DataRetrieverService);
module.service('localStorage', LocalStorage);
module.service('datePickerService', DatePickerService);



// WEBPACK FOOTER //
// ./src/scripts/services/index.js